export default "__VITE_ASSET__CtWzV8db__"